export default "__VITE_ASSET__CnKSH$jh__"